import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

export interface ConfirmDialogConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmIcon?: string;
  cancelIcon?: string;
  confirmButtonClass?: string;
  cancelButtonClass?: string;
  icon?: string;
  iconClass?: string;
  iconBgClass?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="p-6">
      <div class="flex flex-col items-center gap-4">
        <!-- Icono -->
        <div [class]="getIconBgClass()" class="flex items-center justify-center w-16 h-16 rounded-full">
          <i [class]="getIconClass()" class="text-4xl"></i>
        </div>

        <!-- Mensaje -->
        <div class="text-center">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
            {{ config.data?.title || 'Confirmar acción' }}
          </h3>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            {{ config.data?.message || '¿Estás seguro de realizar esta acción?' }}
          </p>
        </div>

        <!-- Botones -->
        <div class="flex gap-3 mt-4 w-full">
          <button
            type="button"
            (click)="onCancel()"
            [class]="getCancelButtonClass()"
          >
            <i [class]="getCancelIcon()" class="mr-2"></i>
            {{ config.data?.cancelText || 'Cancelar' }}
          </button>
          <button
            type="button"
            (click)="onConfirm()"
            [class]="getConfirmButtonClass()"
          >
            <i [class]="getConfirmIcon()" class="mr-2"></i>
            {{ config.data?.confirmText || 'Confirmar' }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class ConfirmDialogComponent {
  protected readonly dialogRef = inject(DynamicDialogRef);
  protected readonly config = inject(DynamicDialogConfig);

  getIconClass(): string {
    const icon = this.config.data?.icon || 'pi pi-question-circle';
    const defaultClass = this.config.data?.iconClass || 'text-blue-600 dark:text-blue-400';
    return `${icon} ${defaultClass}`;
  }

  getIconBgClass(): string {
    return this.config.data?.iconBgClass || 'bg-blue-100 dark:bg-blue-900/30';
  }

  getConfirmButtonClass(): string {
    return this.config.data?.confirmButtonClass || 
      'flex-1 px-4 py-2 bg-primary hover:bg-primary-900 text-white rounded-md text-sm font-semibold transition cursor-pointer';
  }

  getCancelButtonClass(): string {
    return this.config.data?.cancelButtonClass || 
      'flex-1 px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md text-sm font-semibold transition cursor-pointer';
  }

  getConfirmIcon(): string {
    return this.config.data?.confirmIcon || 'pi pi-check';
  }

  getCancelIcon(): string {
    return this.config.data?.cancelIcon || 'pi pi-times';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}

